
// export const companyInfoReducers = (state=[],action) =>{//آرایه ای
//     switch(action.type){
//         case "GET":
//             return [... action.payload];
//         default:
//             return state;
//     }
// };

export const customerReducer = (state={},action) =>{
    switch(action.type){
        case "ADD":
            return {...action.payload};
        case "UPDATE":
            return {...action.payload};
        case "CLEAR":
            return {...action.payload};
        default:
            return state;
    }
};
